<template>
  <div>
    <el-card>
      <el-form ref="occurrence" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code">
              <el-input
                ref="code"
                disabled
                v-model="occurrence.code"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item :label="$t('descricao')" prop="description">
              <el-input
                disabled
                ref="description"
                v-model="occurrence.description"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('tipo')" prop="type">
              <el-input
                disabled
                ref="type"
                v-model="occurrence.type"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item :label="$t('acao')" prop="action">
              <el-input
                disabled
                ref="action"
                v-model="occurrence.action.description"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5" style="margin-top: 20px">
          <el-col :xs="15" :sm="11" :md="11" :lg="6" :xl="6">
            <el-form-item :label="$t('possui-anexo')" prop="attachments">
              <el-radio v-model="attachments" :label="true" disabled
                >Sim</el-radio
              >
              <el-radio v-model="attachments" :label="false" disabled
                >Não</el-radio
              >
            </el-form-item>
          </el-col>

          <el-col
            :xs="15"
            :sm="11"
            :md="11"
            :lg="6"
            :xl="6"
            v-if="collecteds.length > 0"
          >
            <el-form-item label="Itens Coletados">
              <ul>
                <li v-for="collected in collecteds" :key="collected.tag">
                  {{ collected.tag }}
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import DriverActionAdd from './DriverActionAdd';
import { i18n } from '@/plugin/i18n';

export default {
  name: 'OccurenceAdd',
  props: ['occurrence', 'attachments', 'collecteds'],
  components: {
    DriverActionAdd,
  },
  data() {
    return {
      occurrenceTypes: [
        {
          code: '1',
          description: 'Informativa',
        },
        {
          code: '2',
          description: 'Gera Pendência',
        },
        {
          code: '3',
          description: 'Finaliza Processo',
        },
      ],
      allDriverActions: [],
      dialogFormVisible: false,
      isDisabled: false,
    };
  },
};
</script>
<style scoped lang="scss">
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.addActionOpt {
  color: red;
}

.el-dialog {
  width: 90% !important;
}

.el-dialog__wrapper {
  top: -50px;
}
</style>
